import { Label, SpinButton } from "@fluentui/react-components";
import PropTypes from "prop-types";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateSheet } from "../../state/styleSheetSlice";

const LineSpacingTable = ({ selectedSheetKey }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedSheet = useSelector(
    (state) => state.styleSheet.draftSheets[selectedSheetKey] ?? state.styleSheet.sheets[selectedSheetKey]
  );

  return (
    <div>
      {/* <Label>{t("stylesheet.other.line-spacing")}</Label> */}
      <div style={{ display: "grid", gridTemplateColumns: "auto auto auto" }}>
        <Label>{t("stylesheet.other.line-spacing.id")}</Label>
        <Label>{t("stylesheet.other.line-spacing.paragraph")}</Label>
        <Label>{t("stylesheet.other.line-spacing.line")}</Label>
        {selectedSheet?.lineSpacing?.map((ls) => (
          <React.Fragment key={ls.id}>
            <div>{ls.id}</div>
            <div>
              <SpinButton
                value={ls.paragraph}
                min={1}
                max={10}
                step={1}
                onChange={(_, d) =>
                  dispatch(updateSheet({ sheetKey: selectedSheetKey, lineSpacing: { id: ls.id, paragraph: d.value } }))
                }
              />
            </div>
            <div>
              <SpinButton
                value={ls.line}
                min={1}
                max={5}
                step={0.05}
                onChange={(_, d) =>
                  dispatch(updateSheet({ sheetKey: selectedSheetKey, lineSpacing: { id: ls.id, line: d.value } }))
                }
              />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

LineSpacingTable.propTypes = {
  selectedSheetKey: PropTypes.string.isRequired,
};

export default LineSpacingTable;
